import { Number as NumberField } from '~/components/field/common/number';
import { NumberFormatValueConverter } from '~/converters/number-format';

export class CurrencyFormatValueConverter extends NumberFormatValueConverter {
	constructor() {
		super('Currency');
	}

	public toView(value, scale?) {
		return this.toViewCurrency(value, scale);
	}
}
